import * as React from "react"

import {ImageSkuBlock, SkuInfoBlock} from "@components"
import {Box} from "@mui/material";


export default function skuColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    }, {
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    }, {
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'sku', label: 'Product',
		options: {
			headerAlign: 'left',
            filterType: 'textField',
			customBodyRowRenderLite: (value, { category, brand, ean, sku, skuID, country, reference }) =>
				<Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							skuID={skuID}
							skuName={sku}
						/>
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
						/>
					</Box>
				</Box>
		}
	}]
}
